import React, { useState, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { LayoutStandardCrud, TableLv2 } from '@/components';
import moment from 'moment';
import TitleFilter from '../component/title-filter';
import './index.less';
import { defaultAxios } from '@/utils';
import { message, DatePicker, Button, Icon } from 'antd';
import _ from 'lodash';

const RangePicker = DatePicker.RangePicker;
const Task321: React.FC = () => {
    const [task321Data, setTask321Data] = useState<any>([]);
    const [task321Loading, setTask321Loading] = useState(false);
    const [acMenuSelect, setACMenuSelect] = useState<string>('');
    const afterDay = moment().subtract(1, 'week');
    const [taskEndTime, setTaskEndTime] = useState({
        start: afterDay.startOf('month').format('YYYY-MM-DD HH:mm:ss'),
        end: afterDay.endOf('month').format('YYYY-MM-DD HH:mm:ss'),
    });
    useEffect(() => {
        if (acMenuSelect) {
            fetchTask321Data();
        }
    }, [acMenuSelect]);
    const tableColumns: any = [
        {
            title: '续约321任务',
            children: [
                {
                    title: '有效任务总数',
                    dataIndex: 'renewal123_task_valid_num',
                },
                {
                    title: '按时完成数',
                    dataIndex: 'renewal123_task_finish_num',
                },
                {
                    title: '按时完成率',
                    dataIndex: 'renewal123_task_finish_rate',
                    render: (v: any) => `${v}%`,
                },
                {
                    title: '逾期完成数',
                    dataIndex: 'renewal123_task_overdue_finish_num',
                },
                {
                    title: '逾期完成率',
                    dataIndex: 'renewal123_task_overdue_finish_rate',
                    render: (v: any) => `${v}%`,
                },
                {
                    title: '扔回公海异常关闭任务数',
                    dataIndex: 'renewal123_task_close_num',
                },
                {
                    title: '逾期未完成数',
                    dataIndex: 'renewal123_task_overdue_unfinish_num',
                },
                {
                    title: '已取消任务数',
                    dataIndex: 'renewal123_task_cancel_num',
                },
            ],
        },
        {
            title: '1个月内到期任务',
            children: [
                {
                    title: '有效任务总数',
                    dataIndex: 'renewal1_task_valid_num',
                },
                {
                    title: '按时完成数',
                    dataIndex: 'renewal1_task_finish_num',
                },
                {
                    title: '按时完成率',
                    dataIndex: 'renewal1_task_finish_rate',
                    render: (v: any) => `${v}%`,
                },
                {
                    title: '逾期完成数',
                    dataIndex: 'renewal1_task_overdue_finish_num',
                },
                {
                    title: '逾期完成率',
                    dataIndex: 'renewal1_task_overdue_finish_rate',
                    render: (v: any) => `${v}%`,
                },
                {
                    title: '扔回公海异常关闭任务数',
                    dataIndex: 'renewal1_task_close_num',
                },
                {
                    title: '逾期未完成数',
                    dataIndex: 'renewal1_task_overdue_unfinish_num',
                },
                {
                    title: '已取消任务数',
                    dataIndex: 'renewal1_task_cancel_num',
                },
            ],
        },
        {
            title: '2个月内到期任务',
            children: [
                {
                    title: '有效任务总数',
                    dataIndex: 'renewal2_task_valid_num',
                },
                {
                    title: '按时完成数',
                    dataIndex: 'renewal2_task_finish_num',
                },
                {
                    title: '按时完成率',
                    dataIndex: 'renewal2_task_finish_rate',
                    render: (v: any) => `${v}%`,
                },
                {
                    title: '逾期完成数',
                    dataIndex: 'renewal2_task_overdue_finish_num',
                },
                {
                    title: '逾期完成率',
                    dataIndex: 'renewal2_task_overdue_finish_rate',
                    render: (v: any) => `${v}%`,
                },
                {
                    title: '扔回公海异常关闭任务数',
                    dataIndex: 'renewal2_task_close_num',
                },
                {
                    title: '逾期未完成数',
                    dataIndex: 'renewal2_task_overdue_unfinish_num',
                },
                {
                    title: '已取消任务数',
                    dataIndex: 'renewal2_task_cancel_num',
                },
            ],
        },
        {
            title: '3个月内到期任务',
            children: [
                {
                    title: '有效任务总数',
                    dataIndex: 'renewal3_task_valid_num',
                },
                {
                    title: '按时完成数',
                    dataIndex: 'renewal3_task_finish_num',
                },
                {
                    title: '按时完成率',
                    dataIndex: 'renewal3_task_finish_rate',
                    render: (v: any) => `${v}%`,
                },
                {
                    title: '逾期完成数',
                    dataIndex: 'renewal3_task_overdue_finish_num',
                },
                {
                    title: '逾期完成率',
                    dataIndex: 'renewal3_task_overdue_finish_rate',
                    render: (v: any) => `${v}%`,
                },
                {
                    title: '扔回公海异常关闭任务数',
                    dataIndex: 'renewal3_task_close_num',
                },
                {
                    title: '逾期未完成数',
                    dataIndex: 'renewal3_task_overdue_unfinish_num',
                },
                {
                    title: '已取消任务数',
                    dataIndex: 'renewal3_task_cancel_num',
                },
            ],
        },
    ];
    if (acMenuSelect) {
        switch (acMenuSelect) {
            case 'country':
                // tableColumns.unshift({
                //     title: '目标等级',
                //     dataIndex: 'level',
                // });
                break;
            case 'personal':
                tableColumns.unshift({
                    title: '销售',
                    dataIndex: 'sale_name',
                    fixed: true,
                });
            case 'group':
                tableColumns.unshift({
                    title: '小组',
                    dataIndex: 'sale_dept_name',
                    fixed: true,
                });
            case 'city':
                tableColumns.unshift({
                    title: '城市',
                    dataIndex: 'sale_city_name',
                    fixed: true,
                });
            case 'area':
                tableColumns.unshift({
                    title: '区域',
                    dataIndex: 'sale_area_name',
                    fixed: true,
                });
            default:
                break;
        }
    }
    const fetchTask321Data = async () => {
        if (!acMenuSelect) {
            // 若无，则代表没权限或权限未加载
            return;
        }
        const url = '/crm/data/query/list_sale_task_statistical_model';
        setTask321Loading(true);
        const needFiledKey: string[] = [];
        _.forEach(tableColumns, item => {
            if (item.children) {
                _.forEach(item.children, cItem => {
                    console.log(cItem);
                    needFiledKey.push(cItem.dataIndex);
                });
            } else {
                needFiledKey.push(item.dataIndex);
            }
        });
        const [d, e] = await defaultAxios.put(url, {
            begin_time: moment(taskEndTime.start).format('YYYY-MM-DD'),
            end_time: moment(taskEndTime.end).format('YYYY-MM-DD'),
            fields: needFiledKey,
        });
        setTask321Loading(false);
        if (d === null || d.data === null) {
            message.error('查询失败～');
            setTask321Data([]);
            return [null, e];
        }
        const data = d.data;
        if (data && Array.isArray(data)) {
            setTask321Data(data);
        } else {
            setTask321Data([]);
            message.error(data?.msg || '查询失败～');
        }
    };
    const exportTask321Data = () => {
        const url = `/bff/api/rest/ana/sales/task321-export?begin_time=${moment(
            taskEndTime.start,
        ).format('YYYY-MM-DD')}&end_time=${moment(taskEndTime.end).format(
            'YYYY-MM-DD',
        )}&exportType=${acMenuSelect}`;
        window.open(url, '_blank');
    };
    const onActionSearchTimeChange = (
        dates: any,
        dateStrings: [string, string],
    ) => {
        // const limitStart = moment(dateStrings[1])
        //     .subtract('3', 'months')
        //     .startOf('days');
        // const startMoment = moment(dateStrings[0]).startOf('days');
        // if (limitStart.isAfter(startMoment)) {
        //     message.warning('请选择小于或等于三个月的时间区间～');
        //     return;
        // }
        setTaskEndTime({
            start: dateStrings[0],
            end: dateStrings[1],
        });
        // reload();
    };
    const renderFilter = () => {
        return (
            <>
                <div
                    className="ana-filter-item"
                    style={{
                        marginRight: '8px',
                        display: 'inline-block',
                    }}
                >
                    <label htmlFor="time">任务截止日期：</label>
                    <RangePicker
                        name="time"
                        disabled={task321Loading}
                        value={[
                            moment(taskEndTime.start),
                            moment(taskEndTime.end),
                        ]}
                        showTime={true}
                        format="YYYY-MM-DD HH:mm:ss"
                        onChange={onActionSearchTimeChange}
                        style={{ width: '400px' }}
                        allowClear={false}
                        onOk={() => {
                            fetchTask321Data();
                        }}
                    />
                </div>
                <Button
                    type="primary"
                    disabled={task321Loading}
                    onClick={() => {
                        exportTask321Data();
                    }}
                    style={{
                        display: 'inline-block',
                    }}
                >
                    导出
                </Button>
                <a
                    style={{
                        fontSize: '14px',
                        marginLeft: '12px',
                        fontWeight: 500,
                    }}
                    target="_blank"
                    href="https://maimai.feishu.cn/wiki/wikcnxkgl0qsmJasNihfGyarFQd"
                >
                    <Icon
                        style={{
                            marginRight: '2px',
                        }}
                        type="question-circle"
                    />
                    口径说明
                </a>
            </>
        );
    };
    return (
        <LayoutStandardCrud
            title={
                <TitleFilter
                    pageKey={'321-task'}
                    onFilter={filterData => {
                        if (filterData) {
                            setACMenuSelect(filterData?.menu);
                        }
                    }}
                />
            }
            message={null}
            popups={null}
            multipleOps={null}
            globalOps={null}
            filters={renderFilter()}
            dataTable={
                <TableLv2
                    dataSource={task321Data}
                    loading={task321Loading}
                    closeRowSelection={true}
                    pagination={false}
                    scroll={{ x: '3000px' }}
                    columns={tableColumns}
                />
            }
        />
    );
};

export default observer(Task321);
